import DocumentsOrderBy from '../models/documentsOrderBy';

const orderByOptions = [
  { value: DocumentsOrderBy.DATE, label: 'Date' },
  { value: DocumentsOrderBy.NAME, label: 'Name' },
];

export default orderByOptions;
